import { withViewAllLovesProps } from 'viewModel/richProfile/viewAllLoves/withViewAllLovesProps';
import ViewAllLoves from 'components/RichProfile/ViewAllLoves/ViewAllLoves';
const ConnectedViewAllLoves = withViewAllLovesProps(ViewAllLoves);

export default ConnectedViewAllLoves;
